import conversation from '../dashboard/conversation/conversation.routes';
import { frontendURL } from 'dashboard/helper/URLHelper';
const MobileLayout = () => import('./MobileLayout.vue');
const MobileConversationsPage = () => import('./MobileConversationsPage.vue');
const MobileNotificationsPage = () => import('./MobileNotificationsPage.vue');
const MobileCallsPage = () => import('./MobileCallsPage.vue');

const mobileBasePath = frontendURL('accounts/:accountId/mobile');

export default {
  path: mobileBasePath,
  component: MobileLayout,
  meta: { mobile: true },
  children: [
    {
      path: '',
      redirect: { name: 'mobile_conversations_index' },
    },
    ...conversation.routes.map(route => ({
      ...route,
      path: route.path.replace('/space/:accountId', mobileBasePath),
      name: `mobile_${route.name}`,
      component: MobileConversationsPage,
    })),
    {
      path: 'notifications',
      name: 'mobile_notifications_index',
      component: MobileNotificationsPage,
      meta: { permissions: ['administrator', 'agent', 'custom_role'] },
    },
    {
      path: 'calls',
      name: 'mobile_calls_index',
      component: MobileCallsPage,
      meta: { permissions: ['administrator', 'agent', 'custom_role'] },
    },
  ],
};
